// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__ighaS","fullHeight":"Layout_fullHeight__i3s3T"};